<div class="EXTRA_SERVICE_TRAVEL_FORM modal-header w-100 d-inline-block border-bottom pb-0 mb-0">
    <div class="d-flex justify-content-between">
      <h4 class="booking-modal-title">Airport Transfers</h4>
      <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
    </div>
    <div>
    </div>
  </div>
  <div class="modal-body p-4 mt-3">
   <p class="my-3 intro">Our team are available on the go to assist & support with your Airport Transfer request.</p>
    <form [formGroup]="form">
        <div class="form-group mb-3">
            <div class="row">
                <div class="col-6 form-input">
                    <label class=" form-label ">
                      Arrival Airport <span class="text-danger">*</span>
                    </label>
                    <app-location-selector className="input-locator" placeholder="Arrival Airport" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeF($event)">
                </app-location-selector>
            </div>
            <div class="col-6 form-input ">
                
                <label class=" form-label ">
                  Departure Airport <span class="text-danger">*</span>
                </label>
                    <app-location-selector className="input-locator" placeholder="Departure Airport" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeT($event)">
                  </app-location-selector>
                </div>
               
              </div>
        </div>
      
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label ">
             Destination <span class="text-danger">*</span>
            </label>
            <app-location-selector className="input-locator" placeholder="Enter final destination of transfer?" [showErrorMsg]="false"
            [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
            (values)="locationChangeJ($event)">
          </app-location-selector>
        </div>
      
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label ">
             Number of Travellers <span class="text-danger">*</span>
            </label>
            <app-input formCtrlName="number_of_travelers" [label]="'How many people are travelling'" inputNumber [formGrp]="form" [required]="true">
            </app-input>
        </div>
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label ">
             Vehicle Type <span class="text-danger">*</span>
            </label>
            <select class="form-control" formControlName="vehicle_type" name="" id="">
                <option value="">Select vehicle type</option>
                <option value="sedan">Sedan</option>
                <option value="mini-bus">Mini Bus</option>
                <option value="van">Van</option>
            </select>
        </div>
        <div class="mb-3 ">
           
            <label class="mt-2 form-label form-toggle">
              Additional Request
            </label>
            <textarea formControlName="additional_requests" 
            placeholder="Any special requests or preferences, such as child's seats or luggage assistance" 
            class="form-control form-input booking-text-area text-body"
              cols="10" rows="5"></textarea>
        
            
        </div>
        <app-button 
                    class="book-btn"
                    [disabled]="form.invalid"
                    (click)="submit()"
                    [className]="'w-100'" warning>
                    {{loading ? 'Loading...': 'Submit'}}
                  </app-button>
    </form>


  </div>
  